import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const EducationPPTXCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { pptx_inc_education, pptx_inc_edu_highestonly, pptx_inc_edu_keyonly, pptx_inc_eduschool, pptx_inc_edufinish } = state

  return (
    <CVCard
      title={t('CVTemplates.Education')}
      description={t('CVTemplates.EducationHistoryAndDegrees')}
      isEnabled={pptx_inc_education}
      toggleName='pptx_inc_education'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='pptx_inc_edu_highestonly'
          label={t('CVTemplates.HighestDegreeOnly')}
          value={pptx_inc_edu_highestonly}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_edu_keyonly'
          label={t('CVTemplates.OnlyKeyEducations')}
          value={pptx_inc_edu_keyonly}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_eduschool'
          label={t('CVTemplates.ShowSchool')}
          value={pptx_inc_eduschool}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_edufinish'
          label={t('CVTemplates.ShowCompletionDate')}
          value={pptx_inc_edufinish}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
